// import vcaLogo from "@/assets/vca-logo.png";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-soft-gray">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="h-16 w-16 bg-navy rounded-full flex items-center justify-center text-white font-bold text-xl mx-auto mb-6">VCA</div>
            <h1 className="text-4xl font-bold text-navy mb-4">Terms of Service</h1>
            <p className="text-gray-600">
              Effective Date: June 17, 2025 | Last Updated: June 17, 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-navy mb-4">1. Agreement to Terms</h2>
            <p className="mb-6">
              By accessing and using the Vaal Cruising Association ("VCA") website, services, or becoming a member, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site and our services.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">2. About VCA</h2>
            <p className="mb-6">
              The Vaal Cruising Association is a boating club established in 1968, located at Aloe Fjord on the Vaal Dam in Gauteng, South Africa. We are dedicated to promoting safe boating, fostering community among boating enthusiasts, and providing excellent facilities and services to our members.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">3. Membership Terms</h2>
            <h3 className="text-xl font-semibold text-navy mb-3">3.1 Membership Application</h3>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li>All membership applications are subject to approval by the VCA Committee</li>
              <li>Applicants must provide accurate and complete information</li>
              <li>Membership fees must be paid in full upon acceptance</li>
              <li>Members must comply with all club rules and regulations</li>
            </ul>

            <h3 className="text-xl font-semibold text-navy mb-3">3.2 Member Responsibilities</h3>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>Conduct themselves in a manner befitting the club's reputation</li>
              <li>Follow all safety regulations and boating guidelines</li>
              <li>Respect club property and facilities</li>
              <li>Pay all fees and charges promptly</li>
              <li>Notify the club of any changes to personal information</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">4. Use of Facilities</h2>
            <p className="mb-4">VCA facilities are available to members subject to the following conditions:</p>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>Facilities must be used safely and responsibly</li>
              <li>Members are liable for any damage caused by their actions</li>
              <li>Club rules and safety regulations must be observed at all times</li>
              <li>The club reserves the right to restrict access to facilities when necessary</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">5. Bar Tab and Financial Services</h2>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>Bar tab services are provided for member convenience</li>
              <li>Members are responsible for all charges incurred on their account</li>
              <li>Outstanding balances must be settled promptly</li>
              <li>The club reserves the right to suspend bar tab privileges for unpaid accounts</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">6. Website Usage</h2>
            <h3 className="text-xl font-semibold text-navy mb-3">6.1 Acceptable Use</h3>
            <p className="mb-4">You may use our website for legitimate purposes only. You agree not to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li>Use the site for any unlawful purpose or prohibited activity</li>
              <li>Attempt to gain unauthorized access to any systems or accounts</li>
              <li>Distribute viruses, malware, or other harmful content</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>

            <h3 className="text-xl font-semibold text-navy mb-3">6.2 User Accounts</h3>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>You are responsible for maintaining the confidentiality of your account credentials</li>
              <li>You must notify us immediately of any unauthorized use of your account</li>
              <li>You are responsible for all activities that occur under your account</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">7. Intellectual Property</h2>
            <p className="mb-6">
              All content on this website, including text, graphics, logos, images, and software, is the property of VCA or its licensors and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or modify any content without written permission.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">8. Privacy and Data Protection</h2>
            <p className="mb-6">
              Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these Terms of Service by reference. By using our services, you consent to the collection and use of information as outlined in our Privacy Policy.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">9. Liability and Disclaimers</h2>
            <h3 className="text-xl font-semibold text-navy mb-3">9.1 Limitation of Liability</h3>
            <p className="mb-4">
              VCA shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from your use of our services or participation in club activities. This includes, but is not limited to, damages for loss of profits, data, or other intangible losses.
            </p>

            <h3 className="text-xl font-semibold text-navy mb-3">9.2 Assumption of Risk</h3>
            <p className="mb-6">
              Boating and water activities involve inherent risks. By participating in club activities, you acknowledge and assume all risks associated with these activities and agree to hold VCA harmless from any claims arising from your participation.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">10. Indemnification</h2>
            <p className="mb-6">
              You agree to indemnify and hold harmless VCA, its officers, directors, employees, and agents from any claims, losses, damages, liabilities, and expenses (including legal fees) arising from your use of our services, violation of these terms, or infringement of any rights of another party.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">11. Termination</h2>
            <p className="mb-4">We reserve the right to terminate or suspend your membership or access to our services at any time for:</p>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>Violation of these Terms of Service</li>
              <li>Breach of club rules or regulations</li>
              <li>Non-payment of fees or charges</li>
              <li>Conduct detrimental to the club or its members</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">12. Governing Law</h2>
            <p className="mb-6">
              These Terms of Service are governed by the laws of the Republic of South Africa. Any disputes arising from these terms or your use of our services shall be subject to the exclusive jurisdiction of the South African courts.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">13. Changes to Terms</h2>
            <p className="mb-6">
              VCA reserves the right to modify these Terms of Service at any time. Changes will be posted on our website with the effective date. Continued use of our services after changes constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">14. Severability</h2>
            <p className="mb-6">
              If any provision of these Terms of Service is found to be unenforceable or invalid, the remaining provisions shall continue to be valid and enforceable to the fullest extent permitted by law.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">15. Contact Information</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="mb-4">
                <strong>Vaal Cruising Association</strong><br />
                <strong>Address:</strong> Aloe Fjord, Vaal Dam, Gauteng, South Africa<br />
                <strong>Email:</strong> info@vaalcruising.co.za<br />
                <strong>Phone:</strong> +27 82 265 4357
              </p>
              <p className="text-sm text-gray-600">
                For questions about these Terms of Service or any club-related matters, please contact us using the information above.
              </p>
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-gray-700">
                <strong>Acknowledgment:</strong> By using VCA services or becoming a member, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service and our Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}